import { ProjectAction } from "../types/projectData"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/projectData"
import projectApi from "../../api/projectDataApi"

function getProjectData(projectId: string) {
  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA })
      const response = await projectApi.getAsinsData(projectId)
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SUCCESS, payload: response })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_ERROR,
        payload: "Error loading projects",
      })
    }
  }
}

export default {
  getProjectData,
}
